import toMap from '~/misc/toMap';

export default toMap([
  'BACKHAUL_TOGGLED',
  'BACKHAUL_LANE_VIEWED',
  'BACKHAUL_BOOKINGLOAD_REVEALED',
  'BACKHAUL_BOOKINGLOAD_OPENED',
]);



// WEBPACK FOOTER //
// ./src/modules/backhaul/types.js